import React from "react";
import "../css/base.css";
import "../css/instruction.css";

const Instruction = props => {
  return (
    <div id="instruction">
      <h3>Instruction</h3>
      <p>
        Hanapegi is a game in which you hold Rock, Paper, or Scissors in both
        hands and choose one of your hands according to the opponent's hand to
        play Rock Paper Scissors.
      </p>
      <br></br>
      <p>
        Leedo Rock Paper Scissors are determined according to the unique number
        of the Leedo NFT card.
      </p>
      <p>
        Therefore, eight pieces of Rock Paper Scissors are created with an
        8-digit unique number from the Leedo NFT, so four games can be created
        per round.
      </p>
      <br></br>
      <p>
        In other words, you can play one round (four games) per Leedo NFT.
        Points are earned for every game you win.
      </p>
      <br></br>
      <p>
        There may be users who do not have Leedo NFT, so all users can play five
        rounds without the NFT card.
      </p>
      <p>
        At this time, the unique number of the NFT to be used is obtained
        randomly from Squid Master.
      </p>
      <br></br>
      <p>
        Your playable rounds are calculated by the number of your NFT cards + 5
        rounds per day.
      </p>
      <ol id="manual">
        ex)
        <li>a user without Leedo NFT can play 5 rounds per day</li>
        <li>a user with 5 Leedo NFTs can play 10 rounds per day. </li>
      </ol>
      <p>
        The game starts when you press Start on the game controller, you just
        need to look at your opponent's hand and select your Rock Paper Scissors
        options.
      </p>
      <br></br>
      <p>
        When you press Start, four games are played in a row, and the game
        proceeds at a fast pace, so you need to concentrate to get points.
      </p>
      <br></br>
      <p>Playable rounds are reset every 00:00(UTC).</p>
      <br></br>
      <p className="pointcausion">These points are not redeemable in cash!! </p>
    </div>
  );
};
export default Instruction;
